export default __webpack_public_path__ + "static/amber-blue-d21d98bcf3d6b8216e13ff69e3f62a65.png";